// src/app/core/store/policy-analytics/policy-analytics.state.ts

import {
  OverviewRow,
  TimeSeriesRow,
  BreakdownRow,
  RankingsRow,
  ComparisonRow,
  ProductSummary,
  ProductAnalyticsConfig,
  CityLookupItem,
  GuaranteeSubtypeLookupItem,
} from '@shared/models/policy-analytics.model';

// ── Async slice (same shape as health-travel store) ──────────────────────────
export interface AsyncSlice<T> {
  data: T | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export function emptySlice<T>(): AsyncSlice<T> {
  return { data: null, loading: false, loaded: false, error: null };
}

// ── State shape ─────────────────────────────────────────────────────────────
export interface PolicyAnalyticsState {
  // ── Product config ──
  products: ProductSummary[];
  productsLoading: boolean;
  productsLoaded: boolean;
  selectedProductTypeId: number | null;
  configs: Record<number, ProductAnalyticsConfig>;  // cache by typeId
  configLoading: boolean;

  // ── Lookups ──
  cities: CityLookupItem[];
  citiesLoaded: boolean;
  guaranteeSubtypes: GuaranteeSubtypeLookupItem[];
  guaranteeSubtypesLoaded: boolean;

  // ── Analytics data ──
  overview:   AsyncSlice<OverviewRow[]>;
  timeSeries: AsyncSlice<TimeSeriesRow[]>;
  breakdown:  AsyncSlice<BreakdownRow[]>;
  rankings:   AsyncSlice<RankingsRow[]>;
  comparison: AsyncSlice<ComparisonRow[]>;
}

export const initialPolicyAnalyticsState: PolicyAnalyticsState = {
  products: [],
  productsLoading: false,
  productsLoaded: false,
  selectedProductTypeId: null,
  configs: {},
  configLoading: false,

  cities: [],
  citiesLoaded: false,
  guaranteeSubtypes: [],
  guaranteeSubtypesLoaded: false,

  overview:   emptySlice(),
  timeSeries: emptySlice(),
  breakdown:  emptySlice(),
  rankings:   emptySlice(),
  comparison: emptySlice(),
};
